/* Place des Arts — <pda-swapper> : échange de contenu SUR PLACE (pas un carrousel).
   Les flèches [data-swap-prev] / [data-swap-next] changent l'index ; à chaque pas,
   les images [data-swap-img="i"], les textes [data-swap-text="champ"] et la cible des
   liens [data-swap-href="champ"] sont mis à jour depuis un JSON embarqué
   (<script type="application/json" data-swap-data>). Cross-fade doux via la classe
   .is-swapping (opacité pilotée en CSS sur images + textes). Le bouton CTA et les
   flèches NE bougent jamais et ne fondent pas — seul leur href change.
   Clamp aux extrémités (flèche désactivée), comme les états du Figma. */
class PdaSwapper extends HTMLElement {
  connectedCallback() {
    const tag = this.querySelector('script[data-swap-data]');
    try { this.items = tag ? JSON.parse(tag.textContent) : []; } catch (_) { this.items = []; }
    this.index = 0;
    this.imgEls = [...this.querySelectorAll('[data-swap-img]')];
    this.textEls = [...this.querySelectorAll('[data-swap-text]')];
    this.hrefEls = [...this.querySelectorAll('[data-swap-href]')];
    this.addEventListener('click', (e) => {
      const t = e.target instanceof Element ? e.target.closest('[data-swap-prev],[data-swap-next]') : null;
      if (!t || t.disabled) return;
      this.go(t.hasAttribute('data-swap-next') ? 1 : -1);
    });
    this.updateNav();
  }
  go(dir) {
    const n = this.items.length;
    if (n < 2) return;
    const next = Math.min(n - 1, Math.max(0, this.index + dir));
    if (next === this.index) return;
    this.index = next;
    this.updateNav();
    this.classList.add('is-swapping');
    clearTimeout(this._t);
    // Échange au creux du fondu ; setTimeout tourne même en onglet caché → l'état
    // final (src/texte/href) est déterministe (vérifiable sans dépendre de l'anim).
    this._t = setTimeout(() => {
      this.apply(this.items[next]);
      // Retrait DIRECT (pas via rAF) : dans l'éditeur Shopify l'onglet preview est
      // *hidden* → rAF gelé → la classe resterait et tout resterait à opacity:0.
      // Le fondu s'effectue à la remontée d'opacité (transition CSS), état déterministe.
      this.classList.remove('is-swapping');
    }, 200);
  }
  apply(item) {
    if (!item) return;
    for (const el of this.textEls) {
      const v = item[el.dataset.swapText];
      el.textContent = v == null ? '' : v;
      el.hidden = !v;
    }
    for (const el of this.hrefEls) {
      const v = item[el.dataset.swapHref];
      if (v) el.setAttribute('href', v);
    }
    const imgs = item.images || [];
    for (const el of this.imgEls) {
      const im = imgs[Number(el.dataset.swapImg) || 0];
      if (!im || !im.src) continue;
      if (el.getAttribute('src') === im.src) continue;
      el.src = im.src;
      if (im.srcset) el.srcset = im.srcset; else el.removeAttribute('srcset');
      if (im.sizes) el.sizes = im.sizes;
      el.alt = im.alt || '';
    }
  }
  updateNav() {
    const n = this.items.length;
    for (const b of this.querySelectorAll('[data-swap-prev]')) b.disabled = this.index <= 0;
    for (const b of this.querySelectorAll('[data-swap-next]')) b.disabled = this.index >= n - 1;
    for (const el of this.querySelectorAll('[data-swap-nav]')) el.hidden = n < 2;
  }
}
if (!customElements.get('pda-swapper')) customElements.define('pda-swapper', PdaSwapper);
